<template>
  <div class="overlay">
    <div id="friends-tab">
      <div class="friends-main-button" @click="selectTab(0)">
        <div class="tab-text" v-bind:class="inviteTabClass">
          {{ $t("friends_invite") }}
        </div>
      </div>
      <div class="friends-main-button separator" @click="selectTab(1)">
        <div class="tab-text" v-bind:class="acceptTabClass">
          {{ $t("friends_accept") }}
        </div>
      </div>
      <div class="friends-main-button" @click="selectTab(2)">
        <div class="tab-text" v-bind:class="manageTabClass">
          {{ $t("friends_manage") }}
        </div>
      </div>

      <div class="boxclose" @click="close"></div>
    </div>

    <b-container class="f-control p-1">
      <b-row class="friends-controls-segment-content">
        <b-col class="p-3">
          <div class="pagination">
            <div
              id="friends-pagination-first"
              class="arrow"
              v-bind:class="previousPageArrowClass"
              @click="previousPage(true)"
            >
              <div class="arrow-left"></div>
            </div>
            <div
              id="friends-pagination-previous"
              class="arrow"
              v-bind:class="previousPageArrowClass"
              @click="previousPage()"
            >
              <div class="arrow-left"></div>
            </div>

            <span id="friends-pagination-current-page" class="current-page">{{
              currentPage
            }}</span>
            <span
              class="pages"
              v-bind:class="nextPageNumberClass"
              @click="nextPage()"
            >
              {{ currentPage + 1 }}
            </span>
            <div
              id="friends-pagination-next"
              class="arrow"
              v-bind:class="nextPageArrowClass"
              @click="nextPage()"
            >
              <div class="arrow-right"></div>
            </div>
            <div
              id="friends-pagination-last"
              class="arrow"
              v-bind:class="nextPageArrowClass"
              @click="nextPage(true)"
            >
              <div class="arrow-right"></div>
            </div>
            <div class="text-right m-auto" v-if="manageTabSelected">
              <h5 class="text-dark">
                {{ generateFriendsCountText() }}
              </h5>
            </div>
          </div>
        </b-col>

        <b-col v-show="inviteTabSelected">
          <div id="friends-search-form">
            <b-form-group
              class="position-relative py-3 m-0"
              id="friends-search-form"
            >
              <b-form-input
                class="icon-indent"
                id="friends-search-input"
                type="text"
                maxlength="16"
                name="search_friend"
                v-model="searchQuery"
                @keyup="searchTimeOut"
                required
                :placeholder="$t('friends_search')"
              ></b-form-input>
              <i class="fas fa-search form-icons py-3 ml-n3"></i>
            </b-form-group>
          </div>
        </b-col>

        <b-col class="p-1" v-if="inviteTabSelected">
          <div class="btn-invite">
            <span class="text">{{ $t("friends_invite_via") }}</span>
            <div class="fb" @click="inviteViaFacebook()">
              <i class="fab fa-facebook"></i> Facebook
            </div>
            <div class="email" @click="inviteViaEmail()">
              <i class="fa fa-envelope"></i> E-mail
            </div>
          </div>
        </b-col>

        <b-col class="p-1 text-right m-2" v-if="acceptTabSelected">
          <div class="d-inline-block accept-btn">
            <div class="btn btn-primary btn-sm" @click="acceptAllFriendRequest">
              <i class="fa fa-check mr-2"></i> {{ $t("friends_accept_all") }}
            </div>
            <div
              class="ml-2 btn btn-danger btn-sm"
              @click="declineAllFriendRequest"
            >
              <i class="fa fa-times mr-2"></i> {{ $t("friends_decline_all") }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div v-if="inviteTabSelected">
      <b-overlay class="f-zone" :show="inviteBusy" rounded="lg" opacity="0.6">
        <b-card
          v-for="friend in filteredPlayingUsers"
          v-bind:key="friend.user_id"
          no-body
          class="overflow-hidden p-1 f-card"
        >
          <b-row no-gutters style="height: 100%">
            <b-col class="f-image">
              <b-img
                rounded="top"
                v-bind:src="getPic(friend)"
                alt="Image"
                class="rounded-0"
                height="60"
                width="60"
              ></b-img>
            </b-col>
            <b-col class="f-data pl-2">
              <b-tooltip
                v-if="friend && friend.user_id"
                variant="info"
                ref="tooltip"
                :target="friend.user_id.toString()"
              >
                <strong>{{ friend.username }}</strong>
              </b-tooltip>
              <div class="f-name" :id="friend.user_id">
                {{ usernameDesigner(friend.username) }}
              </div>
              <div class="f-label">{{ $t("friends_last_login") }}:</div>
              <div class="f-login">
                <span name="last-login">{{
                  formatLastLogin(friend.last_login)
                }}</span>
              </div>
              <div class="f-buttons">
                <button class="btn btn-primary" @click="invite(friend)">
                  {{ $t("friends_invite") }}
                </button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-overlay>
    </div>

    <div v-if="acceptTabSelected">
      <b-overlay class="f-zone" :show="acceptBusy" rounded="lg" opacity="0.6">
        <b-card
          v-for="friend in filteredFriendRequests"
          v-bind:key="friend.friend_id"
          no-body
          class="overflow-hidden p-1 f-card"
        >
          <b-row no-gutters style="height: 100%">
            <b-col class="f-image">
              <b-img
                rounded="top"
                v-bind:src="getPic(friend)"
                alt="Image"
                class="rounded-0"
                height="60"
                width="60"
              ></b-img>
            </b-col>
            <b-col class="f-data pl-2">
              <b-tooltip
                v-if="friend && friend.id"
                variant="info"
                ref="tooltip"
                :target="friend.id.toString()"
              >
                <strong>{{ friend.username }}</strong>
              </b-tooltip>
              <div class="f-name" :id="friend.id">
                {{ usernameDesigner(friend.username) }}
              </div>
              <div class="f-label">{{ $t("friends_last_login") }}:</div>
              <div class="f-login">
                <span name="last-login">{{
                  formatLastLogin(friend.last_login)
                }}</span>
              </div>
              <div class="f-buttons">
                <button
                  class="btn mr-1 btn-primary solid"
                  @click="acceptFriendRequest(friend)"
                >
                  {{ $t("friends_accept") }}
                </button>
                <button
                  class="btn btn-danger solid"
                  @click="declineFriendRequest(friend)"
                >
                  {{ $t("friends_decline") }}
                </button>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <p v-if="filteredFriendRequests.length === 0">
          {{ $t("friends_no_pending_invitations") }}
        </p>
      </b-overlay>
    </div>

    <div v-if="manageTabSelected">
      <b-overlay class="f-zone" :show="manageBusy" rounded="lg" opacity="0.6">
        <b-card
          v-for="friend in filteredFriends"
          v-bind:key="friend.friend_id"
          no-body
          class="overflow-hidden p-1 f-card"
        >
          <b-row no-gutters style="height: 100%">
            <b-col class="f-image">
              <b-img
                rounded="top"
                v-bind:src="getPic(friend)"
                alt="Image"
                class="rounded-0"
                height="60"
                width="60"
              ></b-img>
            </b-col>
            <b-col class="f-data pl-2">
              <b-tooltip
                v-if="friend && friend.id"
                variant="info"
                ref="tooltip"
                :target="friend.id.toString()"
              >
                <strong>{{ friend.username }}</strong>
              </b-tooltip>
              <div class="f-name" :id="friend.id">
                {{ usernameDesigner(friend.username) }}
              </div>
              <div class="f-label">{{ $t("friends_last_login") }}:</div>
              <div class="f-login">
                <span name="last-login">{{
                  formatLastLogin(friend.last_login)
                }}</span>
              </div>
              <div class="f-buttons">
                <button class="btn btn-danger" @click="deleteFriend(friend)">
                  {{ $t("friends_delete") }}
                </button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-overlay>
    </div>

    <b-modal
      v-model="showInviteForm"
      hide-footer
      hide-header
      size="md"
      centered
      body-class="p-3"
      no-fade
      no-close-on-esc
      no-close-on-backdrop
      modal-class="invite-form"
    >
      <b-overlay :show="pending" rounded="md">
        <b-form @submit="onInviteFormSubmit">
          <b-form-group>
            <b-container>
              <h3 class="form-header">{{ $t("invite_headline") }}</h3>
              <p class="subtext">{{ $t("invite_description") }}</p>
            </b-container>
            <b-container class="position-relative">
              <b-form-input
                class="icon-indent"
                v-model="inviteForm.email"
                type="email"
                required
                :placeholder="$t('email')"
              ></b-form-input>
              <i class="fas fa-envelope form-icons"></i>
            </b-container>
          </b-form-group>

          <b-form-group>
            <b-container>
              <b-form-textarea
                v-model="inviteForm.message"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-container>
          </b-form-group>

          <b-container>
            <b-form-invalid-feedback :state="inviteValidation">
              {{ inviteError }}
            </b-form-invalid-feedback>
          </b-container>

          <b-container class="text-center">
            <button
              type="button"
              class="btn btn-default solid"
              @click="showInviteForm = false"
            >
              {{ $t("cancel") }}
            </button>
            <button type="submit" class="btn btn-primary solid">
              {{ $t("send") }}
            </button>
          </b-container>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import EventBus from "../core/EventBus";
import {
  initFacebookSdk,
  formatTimestampToDate,
  isProduction,
  polishedPictureUrl
} from "../core/utils/index";

export default {
  name: "FriendsManagement",
  props: {},
  data() {
    return {
      user: this.$store.getters.getUser,
      game: this.$store.getters.getGame,
      eventBus: new EventBus(),
      friendPerPage: 21,
      friendPerRow: 3,
      currentPage: 1,
      friends: [],
      playingUsers: [],
      friendRequests: [],
      searchQuery: "",
      recomputeCounter: 0,
      inviteTabSelected: true,
      acceptTabSelected: false,
      manageTabSelected: false,
      inviteBusy: false,
      acceptBusy: false,
      manageBusy: false,
      usersInTab: [],
      inviteForm: {},
      showInviteForm: false,
      pending: false,
      inviteError: null,
      userModal: false,
      searchPlayerData: []
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    invite(friend) {
      this.inviteBusy = true;
      this.$store.dispatch("inviteUser", friend.user_id).then(() => {
        this.inviteBusy = false;
        friend.invited = true;
        // It is required for forcing update on compute method
        this.recomputeCounter++;

        new EventBus().broadcast("NOTIFICATION", {
          success: true,
          message: this.$t("invite_send")
        });
      });
    },
    inviteViaFacebook() {
      const vm = this;
      initFacebookSdk(vm.$store.getters.getLocale).then(() => {
        const invitelink = vm.generateInviteLink();
        const inviteText = vm.generateInviteText(invitelink);
        // eslint-disable-next-line no-undef
        FB.ui({
          method: "send",
          message: "Facebook Friend Invitation",
          title: `${vm.$t("invite")} - ${vm.game.gameName}`,
          link: invitelink,
          description: inviteText
        });
      });
    },
    inviteViaEmail() {
      this.showInviteForm = true;
    },
    onInviteFormSubmit(e) {
      e.preventDefault();

      if (!this.inviteForm.email || !this.inviteForm.message) return;
      const vm = this;
      vm.pending = true;
      vm.$store
        .dispatch("inviteUserViaEmail", vm.inviteForm)
        .then(() => {
          vm.pending = false;
          vm.showInviteForm = false;

          new EventBus().broadcast("NOTIFICATION", {
            success: true,
            message: vm.$t("invite_send")
          });
        })
        .catch(error => {
          vm.pending = false;
          vm.inviteError = error;
        });
    },
    getPic(friend) {
      return polishedPictureUrl(friend.picture);
    },
    nextPage(toTheEnd) {
      if (!toTheEnd) this.currentPage++;
      else {
        this.currentPage = parseInt(
          this.usersInTab.length / this.friendPerPage
        );
      }
    },
    previousPage(toTheStart) {
      if (!toTheStart) this.currentPage--;
      else this.currentPage = 1;
    },
    selectTab(tabIndex) {
      this.inviteTabSelected = false;
      this.acceptTabSelected = false;
      this.manageTabSelected = false;
      this.currentPage = 1;

      if (tabIndex === 0) {
        this.inviteTabSelected = true;
        this.fetchPlayingUserList();
      }
      if (tabIndex === 1) {
        this.acceptTabSelected = true;
        this.fetchFriendRequestList();
      }
      if (tabIndex === 2) {
        this.manageTabSelected = true;
        this.fetchFriendList();
      }
    },
    fetchFriendList() {
      this.manageBusy = true;
      const vm = this;
      this.$store.dispatch("fetchFriends").then(() => {
        vm.friends = vm.$store.getters.getUser.friendsList;
        vm.friends.sort((a, b) => a.username.localeCompare(b.username));
        vm.manageBusy = false;
        vm.usersInTab = vm.friends;
      });
    },
    fetchFriendRequestList() {
      this.acceptBusy = true;
      const vm = this;
      this.$store.dispatch("fetchFriendRequests").then(list => {
        vm.friendRequests = list.sort((a, b) =>
          a.username.localeCompare(b.username)
        );
        vm.acceptBusy = false;
        vm.usersInTab = vm.friendRequests;
      });
    },
    fetchPlayingUserList() {
      this.inviteBusy = true;
      const vm = this;
      this.$store.dispatch("fetchPlayingUsers").then(list => {
        vm.playingUsers = list;
        vm.inviteBusy = false;
        vm.usersInTab = vm.playingUsers;
      });
    },
    acceptFriendRequest(friend) {
      this.acceptBusy = true;
      const vm = this;
      this.$store
        .dispatch("acceptFriendRequest", friend.friend_id)
        .then(() => {
          const findex = this.friendRequests.findIndex(el => {
            return el.friend_id === friend.friend_id;
          });
          vm.friendRequests.splice(findex, 1);
          vm.$forceUpdate();
          vm.acceptBusy = false;
        })
        .catch(err => {
          vm.acceptBusy = false;
          console.log(err);
        });
    },
    declineFriendRequest(friend) {
      this.acceptBusy = true;
      const vm = this;
      this.$store
        .dispatch("declineFriendRequest", friend.friend_id)
        .then(() => {
          const findex = this.friendRequests.findIndex(el => {
            return el.friend_id === friend.friend_id;
          });
          vm.friendRequests.splice(findex, 1);
          vm.$forceUpdate();
          vm.acceptBusy = false;
        })
        .catch(err => {
          vm.acceptBusy = false;
          console.log(err);
        });
    },
    acceptAllFriendRequest() {
      const vm = this;
      vm.acceptBusy = true;
      const promiseList = [];
      vm.friendRequests.forEach(request => {
        const friendId = request.friend_id;
        promiseList.push(vm.$store.dispatch("acceptFriendRequest", friendId));
      });

      Promise.all(promiseList).then(() => {
        vm.acceptBusy = false;
        vm.friendRequests.splice(0);
        vm.$forceUpdate();
      });
    },
    declineAllFriendRequest() {
      const vm = this;
      vm.acceptBusy = true;
      const promiseList = [];
      vm.friendRequests.forEach(request => {
        const friendId = request.friend_id;
        promiseList.push(vm.$store.dispatch("declineFriendRequest", friendId));
      });

      Promise.all(promiseList).then(() => {
        vm.acceptBusy = false;
        vm.friendRequests.splice(0);
        vm.$forceUpdate();
      });
    },
    deleteFriend(friend) {
      this.manageBusy = true;
      const vm = this;
      this.$store
        .dispatch("deleteFriend", friend.friend_id)
        .then(() => {
          const findex = vm.friends.findIndex(el => {
            return el.friend_id === friend.friend_id;
          });
          vm.friends.splice(findex, 1);
          vm.$forceUpdate();
          localStorage.setItem("gd_plus_user", JSON.stringify(vm.user));
          vm.manageBusy = false;
        })
        .catch(err => {
          vm.manageBusy = false;
          console.log(err);
        });
    },

    generateInviteText(link) {
      const text = this.$t("invite_mail");
      return text
        .replace(":username", this.user.username)
        .replace(":link", link)
        .replace(":game", this.game.gameName);
    },
    generateInviteLink() {
      const url = isProduction
        ? "https://play.plus.gamedistribution.com"
        : "https://play-staging.plus.gamedistribution.com";
      return `${url}/${this.game.gameName}?ref=${this.user.uid}
        &domain=${this.$store.getters.getDomain}`;
    },
    formatLastLogin(timestamp) {
      return formatTimestampToDate(timestamp, "MMMM Do YYYY, h:mm:ss");
    },
    generateFriendsCountText() {
      const text = this.$t("x_friends");
      return text.replace(":x", this.friends.length);
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.searchPlayingUser();
      }, 2000);
    },
    searchPlayingUser() {
      // users playing the game
      if (this.searchQuery !== "") {
        this.usersInTab = [];
        let vm = this;
        vm.inviteBusy = true;
        vm.$store
          .dispatch("searchPlayingUser", this.searchQuery)
          .then(response => {
            this.usersInTab = response;
            vm.inviteBusy = false;
          })
          .catch(error => {
            vm.inviteBusy = false;
            console.log(error);
          });
      } else {
        this.fetchPlayingUserList();
      }
      clearTimeout(this.timeOut);
    },
    usernameDesigner(value) {
      //username shortening function
      let name = [];
      for (let i = 0; i < value.length; i++) {
        if (i <= 12) {
          name.push(value[i]);
        }
      }
      let username = name.join("");
      if (username.length >= 12) {
        username = username + "..";
      }
      return username;
    }
  },
  computed: {
    filteredPlayingUsers() {
      // It is required for forcing update on compute method
      console.info(this.recomputeCounter);

      let chunkedArray = [];
      chunkedArray = [...this.usersInTab];
      if (chunkedArray.length > this.friendPerPage) {
        return chunkedArray
          .slice(
            this.currentPage * this.friendPerPage - this.friendPerPage,
            this.currentPage * this.friendPerPage
          )
          .filter(c => !c.invited);
      }
      return chunkedArray.filter(c => !c.invited);
    },
    filteredFriendRequests() {
      // It is required for forcing update on compute method
      console.info(this.recomputeCounter);

      let chunkedArray = [...this.usersInTab];
      if (chunkedArray.length > this.friendPerPage) {
        return chunkedArray
          .slice(
            this.currentPage * this.friendPerPage - this.friendPerPage,
            this.currentPage * this.friendPerPage
          )
          .filter(c => !c.invited);
      }
      return chunkedArray.filter(c => !c.invited);
    },
    filteredFriends() {
      // It is required for forcing update on compute method
      console.info(this.recomputeCounter);

      let chunkedArray = [...this.usersInTab];
      if (chunkedArray.length > this.friendPerPage) {
        return chunkedArray
          .slice(
            this.currentPage * this.friendPerPage - this.friendPerPage,
            this.currentPage * this.friendPerPage
          )
          .filter(c => !c.invited);
      }
      return chunkedArray.filter(c => !c.invited);
    },
    previousPageArrowClass() {
      if (this.currentPage > 1) return "";
      return "disabled";
    },
    nextPageArrowClass() {
      if (this.currentPage < this.usersInTab.length / this.friendPerPage)
        return "";
      return "disabled";
    },
    nextPageNumberClass() {
      if (this.currentPage < this.usersInTab.length / this.friendPerPage)
        return "";
      return "d-none";
    },
    acceptTabClass() {
      if (!this.acceptTabSelected) return "";
      return "selected";
    },
    inviteTabClass() {
      if (!this.inviteTabSelected) return "";
      return "selected";
    },
    manageTabClass() {
      if (!this.manageTabSelected) return "";
      return "selected";
    },
    inviteValidation() {
      return !this.inviteError;
    }
  },

  beforeMount() {
    this.fetchPlayingUserList();
    this.inviteForm.link = this.generateInviteLink();
  }
};
</script>
